import React from 'react';
import PropTypes from 'prop-types';
import { useDispatch } from 'react-redux';
import s from '../QuantQualModule.module.css';
import { getAVGScoreColumn } from '../../QuantQual/qqComponents/componentFunctions';
import { roundtoTwoDecimals } from '../../../../util/util';
import { clickBySubunit } from '../../../../analyticsEvents.js';

import PaginatedTable from '../../../../../components/PaginatedTable/PaginatedTable';

const noop = () => {};
const performanceBySubmodulesComponent = ({
  data: propsData,
  onTabChange = noop,
  studentId,
  reportType,
  sendEvent,
}) => {

  const dispatch = useDispatch();

  const handleUnitClick = () => {
    dispatch(sendEvent(clickBySubunit(reportType)));
  };

  const tableStyle = [
    {
      row: 'styledRow',
      cells: [
        { accessor: 'name', alignment: 'left' },
        { accessor: 'assignments', alignment: 'right' },
        { accessor: 'completedAssignmentsPercentage', alignment: 'right' },
        { accessor: 'correctOnFirstTry', alignment: 'right' },
      ],
    },
  ];

  const avgScoreColumn = {
    accessor: 'correctOnFirstTry',
    Header: 'Questions Correct on First Try',
    cell:
      (item) => {
        if (item.correctOnFirstTry === '—') {
          item.isNullState = true;
        }
        return (getAVGScoreColumn(item, 'correctOnFirstTry'));
      },
  };

  const tableColumns = [
    {
      accessor: 'name',
      Header: 'Subunit Title',
      cell: item =>
        (<button
          role="link"
          className={s.submoduleLink}
          onClick={() => {
            const tabName = studentId ? `reports/type/student-subunit/${studentId}/${item.id}?activeTab=Reports` : `reports/type/subunit/${item.id}`;
            onTabChange(tabName);
            handleUnitClick();
          }}
        >
          {item.name}
        </button>)
      ,
    },
    {
      accessor: 'assignments',
      Header: 'Assignments in Subunit',
      cell: item => (item.assignments >= 0 ? item.assignments : 0),
    },
    {
      accessor: 'completedAssignmentsPercentage',
      Header: 'Assignments Completed',
      cell: (item) => {
        const formatedItem = item.completedAssignmentsPercentage < 0 ? '—' : `${roundtoTwoDecimals(item.completedAssignmentsPercentage)}%`;
        return formatedItem;
      },
    },
  ];
  tableColumns.push(avgScoreColumn);

  const modalContent = (
    <div className={s.modalContent}>
      <p><b>Assignments in Subunit</b> represents the total number of resources (readings, activities, assessments) assigned to your students in this Subunit.</p>
      <p><b>Assignments completed</b> represents the proportion of assignments in this Subunit completed across all students in your class.</p>
      <p><b>Questions correct on first try</b> represents, across all questions answered in this Subunit by all students in your class, the proportion that were correct on a student&apos;s first try.</p>
    </div>
  );

  const nullStateContent = (
    <p>
      There are no assignments covering this unit.<br />
      Go to <button role="link" onClick={() => { onTabChange('assignments'); }}>Course Planner</button> tab to setup and manage assignments.
    </p>
  );

  const data = propsData.map(subunit => ({
    ...subunit,
  }));

  return (
    <div className={s.performanceBySubmodule} data-test-id={`${reportType}-performance-by-subunit`}>
      <PaginatedTable
        id="performanceBySubmodule"
        className={s.performanceCard}
        title="Performance by Subunit"
        data={data}
        tableStyle={tableStyle}
        tableColumns={tableColumns}
        sortBy={['correctOnFirstTry', 'completedAssignmentsPercentage', 'assignments', 'name']}
        direction="asc"
        modalContent={modalContent}
        nullState={nullStateContent}
        styleFunction={() => 'styledRow'}
        reportType={reportType}
      />
    </div>
  );
};

performanceBySubmodulesComponent.propTypes = {
  data: PropTypes.array,
  onTabChange: PropTypes.func,
  reportType: PropTypes.string,
  studentId: PropTypes.string.isRequired,
};

export default performanceBySubmodulesComponent;

